import styles from "./styles.module.scss";

function Loading(): JSX.Element {
  return (
    <div className={styles.wrapper}>
      <div />
      <div />
    </div>
  );
}

export default Loading;
